// extracted by mini-css-extract-plugin
export default {"no_margin":"styles_no_margin__ptNp7","container":"styles_container__5h3b5","primary":"styles_primary__pB+zM"};